// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#0A2145","menuActiveText":"#0C66FF","subMenuActiveText":"#0A2145","menuBg":"#fff","menuHover":"#F1F7FF","subMenuBg":"#fff","subMenuHover":"#F1F7FF","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 44